<template>
    <div class="table-special">
        <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition baikeCat"  style="min-width:403px;">
                    <span class="label" >选择分类</span>
                    <div class="input-condition" >
                        <el-select v-model="condition.up_cat_id" placeholder="请选择一级分类"   @change="getChildren" style="margin-right:10px;">
                            <el-option v-for="item in topLevel" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                        </el-select>
                         <el-select v-model="condition.cat_id" placeholder="请选择二级分类">
                            <el-option v-for="item in childrenLevel" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">文章标题</span>
                    <div class="input-condition">
                        <el-input v-model="condition.title" maxlength="30" placeholder="请输入文章标题名称"></el-input>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">文章ID</span>
                    <div class="input-condition">
                        <el-input v-model="condition.id" type="number" placeholder="请输入文章ID"></el-input>
                    </div>
                </div>
                <div class="search-condition search-condition-time" style="min-width: 400px;">
                    <span class="label">保存时间</span>
                    <div class="input-condition">
                        <el-date-picker
                                v-model="condition.time"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="请选择开始日期"
                                end-placeholder="请选择结束日期"
                                align="right"
                                value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                @change="condition.timestamp = ''"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label" >发布人</span>
                    <div class="input-condition">
                        <el-input v-model="condition.creator" maxlength="30" placeholder="请输入文章发布人名称"></el-input>
                    </div>
                </div>
               
            </div>
            <div class="btn-condition">
                <el-button type="primary" @click="handleSearch()">查 询</el-button>
                <el-button  @click="resetSearch()">清空条件</el-button>
            </div>
        </div>
        <el-table
                :data="list"
                style="width: 100%"
                :highlight-current-row="true"
                stripe
                tooltip-effect="dark"
                ref="multipleTable"
                v-loading="isLoading"
                header-cell-class-name="table-back"
                class="list-table"
        >
            <el-table-column  label="ID" prop="id" width="100"></el-table-column>
            <el-table-column  label="标题">
                <template scope="scope">
                    <a v-if="scope.row.url" :href="scope.row.url" target="_blank" style="text-decoration:none;cursor: pointer;">{{scope.row.title}}</a>
                    <span v-else>{{scope.row.title}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="分类" prop="category_name" ></el-table-column>
            <el-table-column  label="发布人" prop="creator"  width="100px"></el-table-column>
            <el-table-column  label="保存时间" prop="updated_at" ></el-table-column>
          
            <el-table-column label="操作"  fixed="right">
                <template slot-scope="scope">
                  <el-button v-permission="'operating.wikipedia.wikipedia-list.list.edit'" size="mini" @click="openEdit(scope.row.id)"
                        >编辑</el-button>
                    <el-button v-permission="'operating.wikipedia.wikipedia-list.list.delete'" size="mini" @click="handleDelete(scope.row.id)"
                        >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
       <template v-if="list.length > 0">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :current-page="condition.page"
            :total="condition.total"
            :page-size="condition.per_page"
            @current-change="currentChange"
          ></el-pagination>
        </template>
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import { listCategoriesLevelOne,lisCategoriesLevelTwo,getWikipediaList,deleteWikipedia,editWikipediaSort} from '@/service/wikipedia'
    import InlineEditableInput from "@/components/inlineEditableInput/index";
  
    export default {
        components: {
            InlineEditableInput
        },
        name: "List",
        data () {
            return {
                list: [],
                condition: {
                    up_cat_id: '',
                    cat_id:'',
                    id:'',
                    creator: '',
                    title:'',
                    time:'',
                    total: 0,
                    status:1,
                    per_page: 10,
                    page: 1,
                },
                topLevel:[],
                childrenLevel:[],
                isLoading: false,
               
            }
        },
        mounted () {
            this.getLeveOne()
            this.initData()
        },
        methods: {

            handleSearch() {
                this.condition.page=1
                var flagRex =/^0/;
                if(this.condition.id.length>0 && flagRex.test(this.condition.id)){
                      this.$message({
                        type: "error",
                        message: "id为大于0的正整数"
                        });
                    return
                }
                this.initData();
            },
            resetSearch() {
                this.condition = {
                    up_cat_id: '',
                    cat_id:'',
                    creator: '',
                    title:'',
                    time:'',
                     id:'',
                    page:1,
                    status:1,
                    per_page:10,
                    total:0
                }
                this.initData();
            },
            openEdit(id) {
                this.$router.push({path: 'editDraft', query: {id:id}})
            },
            getChildren(val){ //查询二级分类
                this.condition.cat_id=''
                lisCategoriesLevelTwo(val).then(data => {
                    this.childrenLevel = data.sub_category;
                });
            },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            getLeveOne(){
                listCategoriesLevelOne({}).then(data => {
                        this.topLevel = data;
                });
            },
            async initData() {
                this.list=[]
                if(this.condition.time.length>1) {
                    this.condition.created_at_start= this.condition.time[0]
                    this.condition.created_at_end = this.condition.time[1]
                }
                await getWikipediaList(this.condition).then((data) => {
                    let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
                    let url = "https://www."+siteurl+'/zhishi/';
                    data.data.forEach((item,index)=>{
                        data.data[index].url =url+item.id+'.html';
                    })
                    this.condition.total=data.total
                    this.list = data.data
                })

               
                //数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
           handleDelete(id) {
                this.$confirm("删除后不可撤回，是否确认操作？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteWikipedia({'id':id})
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            },
        }
    }
</script>

<style scoped>
.list-table {
    padding: 0 20px;
    box-sizing: border-box;
}
.baikeCat .el-select{
    width:48%;
    float:left;
}
</style>



















